import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ActionItemModel } from '@src/app/modules/actions';

@Component({
  selector: 'chat-details-item',
  templateUrl: './chat-details-item.component.html',
  styleUrls: ['./chat-details-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})
export class ChatDetailsItemComponent {
  @Input() icon?: string;
  @Input() label?: string;
  @Input() actions?: ActionItemModel[];
}
